/*!
 * The Fresh Print — Design Preview in Cart
 * Reads design thumbnails from localStorage and injects them into cart items.
 */
(function () {
  'use strict';

  function injectPreviews() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return;

        cart.items.forEach(function (item, index) {
          var ref = item.properties && item.properties['_design_ref'];
          if (!ref) return;

          var thumb;
          try { thumb = localStorage.getItem(ref + '_thumb'); } catch (e) {}
          if (!thumb) return;

          /* Cart page uses id="CartItem-1", CartItem-2, etc. */
          var row = document.getElementById('CartItem-' + (index + 1));
          if (!row) return;

          /* Don't inject twice */
          if (row.querySelector('.fp-cart-preview')) return;

          var details = row.querySelector('.cart-item__details');
          if (!details) return;

          var wrap = document.createElement('div');
          wrap.className = 'fp-cart-preview';
          wrap.innerHTML =
            '<p class="fp-cart-preview-label">Your Design</p>' +
            '<img src="' + thumb + '" alt="Your custom design" class="fp-cart-preview-img">';
          details.appendChild(wrap);
        });
      })
      .catch(function () {});
  }

  /* Run on initial page load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectPreviews);
  } else {
    injectPreviews();
  }

  /* Re-run when the cart drawer refreshes its content */
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && (node.classList.contains('cart-item') || node.querySelector('.cart-item'))) {
          injectPreviews();
        }
      });
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    var cartDrawer = document.getElementById('CartDrawer');
    if (cartDrawer) observer.observe(cartDrawer, { childList: true, subtree: true });

    var cartItems = document.getElementById('main-cart-items');
    if (cartItems) observer.observe(cartItems, { childList: true, subtree: true });
  });
})();
